import LottieAnimator from "@Components/LottieAnimator";

const AnimatedPageLoader = () => (
  <div style={{ height: "80px", width: "80px" }}>
    <LottieAnimator
      animationData="Loading_Animation.json"
      renderer="svg"
      id="payment-form-success"
    />
  </div>
);

export default AnimatedPageLoader;
